import React, { useState, useContext, useEffect } from 'react';
import { ShopContext } from '../Context/ShopContext';
import './CSS/Profile.css';

// --- UI/UX UPGRADE: Import the toast library ---
import { toast } from 'react-toastify';

const Profile = () => {
    const { user, updateProfile, updatePassword, logout } = useContext(ShopContext);
    
    // State for the forms
    const [username, setUsername] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [oldPassword, setOldPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');

    // --- UI/UX UPGRADE: State to manage button loading states ---
    const [isProfileUpdating, setIsProfileUpdating] = useState(false);
    const [isPasswordUpdating, setIsPasswordUpdating] = useState(false);
    
    useEffect(() => {
        if (user) {
            setUsername(user.username);
            setPhoneNumber(user.phoneNumber || '');
        }
    }, [user]);

    const handleUpdateProfile = async (e) => {
        e.preventDefault();

        const phoneRegex = /^[0-9]{10}$/;
        if (phoneNumber && !phoneRegex.test(phoneNumber)) {
            // --- Replaced alert with toast.warn ---
            toast.warn("Please enter a valid 10-digit phone number or leave the field empty.");
            return;
        }

        setIsProfileUpdating(true); // Disable the button
        try {
            const result = await updateProfile({ username, phoneNumber });
            if (result.success) {
                // --- Replaced alert with toast.success ---
                toast.success(result.message);
            } else {
                // --- Replaced alert with toast.error ---
                toast.error(`Error: ${result.error}`);
            }
        } finally {
            setIsProfileUpdating(false); // Re-enable the button
        }
    };

    const handleUpdatePassword = async (e) => {
        e.preventDefault();
        if (!oldPassword || !newPassword) {
            toast.warn("Please fill in both password fields.");
            return;
        }

        setIsPasswordUpdating(true); // Disable the button
        try {
            const result = await updatePassword({ oldPassword, newPassword });
            if (result.success) {
                toast.success(result.message);
                logout(); 
            } else {
                toast.error(`Error: ${result.error}`);
            }
        } finally {
            setIsPasswordUpdating(false); // Re-enable the button
        }
    };

    if (!user) {
        // We'll replace this with a spinner in a later phase
        return <p>Loading profile...</p>;
    }

    return (
        <div className="profile-page">
            <h1>My Profile</h1>

            <div className="profile-section">
                <h2>Update Profile Details</h2>
                <form onSubmit={handleUpdateProfile} className="profile-form">
                    <div className="form-group">
                        <label htmlFor="username">Username</label>
                        <input 
                            type="text" 
                            id="username"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="phone">Phone Number (for delivery)</label>
                        <input 
                            type="tel" 
                            id="phone"
                            value={phoneNumber}
                            placeholder="Enter 10-digit number"
                            onChange={(e) => setPhoneNumber(e.target.value)}
                        />
                    </div>
                    {/* --- UI/UX UPGRADE: Added loading state to button --- */}
                    <button type="submit" disabled={isProfileUpdating}>
                        {isProfileUpdating ? 'Updating...' : 'Update Profile'}
                    </button>
                </form>
            </div>

            <div className="profile-section">
                <h2>Update Password</h2>
                <form onSubmit={handleUpdatePassword} className="profile-form">
                    <div className="form-group">
                        <label htmlFor="old-password">Old Password</label>
                        <input 
                            type="password" 
                            id="old-password"
                            value={oldPassword}
                            onChange={(e) => setOldPassword(e.target.value)}
                            placeholder="Enter your current password"
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="new-password">New Password</label>
                        <input 
                            type="password" 
                            id="new-password"
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                            placeholder="Enter your new password"
                        />
                    </div>
                    {/* --- UI/UX UPGRADE: Added loading state to button --- */}
                    <button type="submit" disabled={isPasswordUpdating}>
                        {isPasswordUpdating ? 'Updating...' : 'Update Password'}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default Profile;